var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { staticClass: "content-container" },
    [
      _c(
        "v-sheet",
        {
          staticClass: "rounded-16",
          class: !_vm.isMobilePort ? "pa-7 pb-0 mt-9" : "pa-6 mt-0",
          attrs: { color: "grey lighten-4" },
        },
        [
          _c(
            "v-row",
            { attrs: { dense: "", justify: "center" } },
            [
              _c("v-col", { attrs: { cols: "12", md: "8" } }, [
                _c(
                  "h3",
                  {
                    staticClass: "font-weight-medium",
                    class: !_vm.isMobilePort ? "text-h3" : "",
                    staticStyle: { "line-height": "150%" },
                    style: _vm.isMobilePort ? `font-size: 32px` : "",
                  },
                  [
                    _c("span", { staticClass: "primary--text" }, [
                      _vm._v("Your trusted source"),
                    ]),
                    _vm._v(" for building"),
                    _c("br"),
                    _vm._v(
                      "\n                    codes, standards and more\n                "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "h6",
                  {
                    staticClass: "font-weight-regular pt-6",
                    class: !_vm.isMobilePort ? "text-h6" : "",
                    style: _vm.isMobilePort ? `font-size: 16px` : "",
                  },
                  [
                    _vm._v(
                      "\n                    From the International Code Council, Digital Codes is the most authoritative\n                    database\n                    of model codes, standards and supplements.\n                "
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c(
                "v-col",
                {
                  staticClass: "text-center pb-0",
                  attrs: { cols: "12", md: "4" },
                },
                [
                  _c("v-img", {
                    attrs: {
                      src: this.asset(
                        require("../../../app/images/homepage/home-header-image.png")
                      ),
                      alt: "Building codes, standards and more",
                      contain: "",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }